"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMutation = exports.useReactMutation = void 0;
var react_query_1 = require("react-query");
function useReactMutation(mutateFn, options) {
    if (options === void 0) { options = {}; }
    var _a = (0, react_query_1.useMutation)(mutateFn, options), isLoading = _a.isLoading, isError = _a.isError, isIdle = _a.isIdle, data = _a.data, error = _a.error, mutate = _a.mutate, reset = _a.reset;
    if (isIdle) {
        return {
            status: 'idle',
            mutate: mutate,
        };
    }
    if (isLoading) {
        return {
            status: 'in-progress',
        };
    }
    if (isError) {
        return {
            status: 'error',
            // @ts-ignore Must exist
            error: error,
            mutate: mutate,
            reset: reset,
        };
    }
    return {
        status: 'success',
        // @ts-ignore Must exist
        data: data,
        mutate: mutate,
        reset: reset,
    };
}
exports.useReactMutation = useReactMutation;
/**
 * @deprecated use useReactMutation instead.
 */
var useMutation = useReactMutation;
exports.useMutation = useMutation;
